module.exports = __webpack_public_path__ + "img/aj.033fa518.jpg";